import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { evBannerAdClick, evBannerAdView } from 'events/search';

import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';
import ImageLazyLoader from 'components/common/ImageLazyLoader';
import Tooltip from 'components/common/Tooltip';
import { MoreInfo } from 'components/icons';
import LandingPageLink from 'components/landing/LandingPageLink';
import css from 'styles/components/search/inlineBannerAd.scss';

const InlineBannerAd = ({ layoutStyle, searchTerm = '', slotDetails: { src, link, alt } }, { marketplace: { shortName, hasBannerAds } }) => {

  const handleClick = useCallback(() => {
    track(evBannerAdClick, { adLocation: 'SEARCH_RESULTS', searchTerm });
    trackEvent('TE_BANNER_AD_CLICK', `searchTerm:${searchTerm}adLocation:RESULTS`);
  }, [searchTerm]);

  useEffect(() => {
    track(evBannerAdView, { adLocation: 'SEARCH_RESULTS', searchTerm });
    trackEvent('TE_BANNER_AD_VIEW', `searchTerm:${searchTerm}adLocation:RESULTS`);
  }, [searchTerm]);

  if (!hasBannerAds) {
    return null;
  }

  const imgProps = { src, alt };
  return (
    <div className={cn(css.inlineAd, layoutStyle)}>
      <LandingPageLink url={link} className={css.innerWrapper} onClick={handleClick}>
        <ImageLazyLoader imgProps={imgProps} />
        <Tooltip
          content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
          wrapperClassName={css.tooltipWrapper}
          tooltipClassName={css.tooltip}
          contentClassName={css.content}
          direction="down"
          tooltipId="inlineBannerAd"
        >
            Sponsored <MoreInfo className={css.icon}/>
        </Tooltip>
      </LandingPageLink>
    </div>
  );
};

InlineBannerAd.propTypes = {
  layoutStyle: PropTypes.string.isRequired
};

InlineBannerAd.contextTypes = {
  marketplace: PropTypes.object
};

export default InlineBannerAd;
